import {
  ACTION_LOAD_BALANCE__REQUEST,
  ACTION_LOAD_BALANCE__SUCCESS,
  ACTION_LOAD_BALANCE__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_BALANCE__REQUEST:
    case ACTION_LOAD_BALANCE__SUCCESS:
      return null;

    case ACTION_LOAD_BALANCE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
